/**
 * @Author: derhaod
 * @Date: 2026-01-20
 * @Explain: AI Summary 模块
 */
export default {
  // 主页面
  'AI.SUMMARY.PAGE.TITLE': 'AI分析',
  'AI.SUMMARY.DATA.SOURCE': '数据来源:',

  // Overview 组件
  'AI.SUMMARY.OVERVIEW.AI.ANALYTICS': 'AI 分析',
  'AI.SUMMARY.OVERVIEW.MODEL': 'Model',

  // Sentiment 组件
  'AI.SUMMARY.SENTIMENT.TITLE': '情感分析',
  'AI.SUMMARY.SENTIMENT.DISTRIBUTION': '情感分布',
  'AI.SUMMARY.SENTIMENT.TOTAL.ANALYZED': '总分析消息数量',
  'AI.SUMMARY.SENTIMENT.PULSE.24H': '72小时情感分布',
  'AI.SUMMARY.SENTIMENT.TIMEZONE': '时区',
  'AI.SUMMARY.SENTIMENT.LEGEND': '情感',
  'AI.SUMMARY.SENTIMENT.SENTIMENT.SCORE': '情感分',

  // HighValuedMessages 组件
  'AI.SUMMARY.HIGH.VALUED.TITLE': '高价值消息',
  'AI.SUMMARY.HIGH.VALUED.BUG.REPORTS': 'Bug报告',
  'AI.SUMMARY.HIGH.VALUED.SUGGESTIONS': '建议',
  'AI.SUMMARY.HIGH.VALUED.COMPLIMENTS': '称赞',
  'AI.SUMMARY.VIEW.CONTENT': '查看对话内容',
  'AI.SUMMARY.HIGH.VALUED.COLLAPSE': '收起',
  'AI.SUMMARY.ANALYZING': 'AI 正在分析中...',
  'AI.SUMMARY.ANALYZING.LABEL': 'AI 分析中：',
  'AI.SUMMARY.CONTEXTUAL.CONVERSATION': '对话语境',

  // 情感类型
  'AI.SUMMARY.SENTIMENT.TYPE.POSITIVE': '积极',
  'AI.SUMMARY.SENTIMENT.TYPE.NEGATIVE': '消极',
  'AI.SUMMARY.SENTIMENT.TYPE.NEUTRAL': '中立',

  // 思考文字
  'AI.SUMMARY.THINKING.ANALYZING.DATA': '正在分析数据...',
  'AI.SUMMARY.THINKING.ORGANIZING.INFO': '正在整理信息...',
  'AI.SUMMARY.THINKING.GENERATING.SUMMARY': '正在生成摘要...',
};
